import { Box, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const ClickableImageTextCard = ({ media, header, link = '' }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = () => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        paddingTop: '100%',
        borderRadius: '32px',
        border: '4px solid #8FAA30',
        cursor: 'pointer',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        boxShadow: '0 6px 16px rgba(0,0,0,0.25)',

        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 12px 28px rgba(0,0,0,0.35)',
        },
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={media}
        alt={header}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(1, 95, 68, 0.65)', // match first file
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: '#f5f7f6',
            fontWeight: 700,
            fontSize: { xs: '1.4rem', sm: '1.6rem' },
            textShadow: '0 2px 8px rgba(0,0,0,0.6)',
          }}
        >
          {header}
        </Typography>
      </Box>
    </Box>
  )
}